<template>
    <div class="menu" style="text-align:center;margin-left:auto;margin-right:auto;">

        <a-menu  theme="light" style="max-width:1000px" :mode="mode" @select="handleSelect" v-model="activeMenu">
            <template v-for="item in menus">
                <a-sub-menu :key="item.id + ''" v-if="item.children && item.children.length > 1">
                    <span slot="title"><zx-icon :type="item.icon" /><span>{{$t('menu.'+item.name)}}</span></span>
                    <a-menu-item v-for="sub in item.children"  :value="sub.route" :key="sub.id + ''">
                        <zx-icon :type="sub.icon" />
                        <span>{{$t('menu.'+sub.name)}}</span>
                    </a-menu-item>
                </a-sub-menu>
                <a-menu-item v-if="item.children && item.children.length == 1" :value="item.children[0].route" :key="item.id + ''" >
                    <zx-icon :type="item.icon"/>
                    <span>{{$t('menu.'+item.name)}}</span>
                </a-menu-item>
                <a-menu-item v-if="!item.children && item.name == 'statistics'" @click="openStatistics()" :value="item.route" :key="item.id + ''" >
                    <zx-icon :type="item.icon"/>
                    <span>{{$t('menu.'+item.name)}}</span>
                </a-menu-item>
                <a-menu-item v-if="!item.children && item.name != 'statistics'" :value="item.route" :key="item.id + ''" >
                  <zx-icon :type="item.icon"/>
                  <span>{{$t('menu.'+item.name)}}</span>
                </a-menu-item>
            </template>
        </a-menu>
    </div>
</template>

<script>
    import Vue from 'vue'
    import config from '@/config'
    import bus from '../../bus/bus'

    export default {
        name: 'ZMenu',
        mounted() {
          this.activeMenu.push(Vue.ls.get('activeMenu') + '')
          bus.$on('routeChange', (route) => {
            if (route.query) {
              this.$router.push({
                path: route.route,
                query: route.query
              })
            } else {
              this.$router.push(route.route)
            }

            this.activeMenu = [route.key + '']
            Vue.ls.set('activeMenu', route.key + '')
          })

        },
        data(){
            return {
                menus: {},
                activeMenu: [],
                mode: 'horizontal'
            }
        },
        created() {
            // let _this = this
            this.$http.get(config.api.menu_url).then((response) => {
                console.log(response)
                this.menus = response.result
            })
        },
        methods:{
            openStatistics(){
              window.open('/#/statistics', '_blank');
            },
            handleSelect(item) {
              if("/statistics" != item.item.value) {
                Vue.ls.set('activeMenu', item.key + '')
                this.$router.push(item.item.value)
              }
              /*
              if("/statistics" != item.item.value) {
                Vue.ls.set('activeMenu', item.key + '')
                this.$router.push(item.item.value)
              }else{
                window.open('/#/statistics', '_blank');
              }

               */
              //Vue.ls.set('activeMenu', item.key + '')
              //this.$router.push(item.item.value)
            }
        }
    }
</script>

<style scoped>
    .ant-menu-horizontal {
        border: 0;
        border-bottom: 0px solid #e8e8e8;
        box-shadow: none;
        line-height: 63px;
        white-space: nowrap;
        box-sizing: border-box;
    }
</style>